import Loader from "./loader";

export default class Nav {
    constructor() {
        // Nav

        this.burger();
        this.news();
    }

    burger() {
        const btn = document.querySelector('.nav__burger');
        const menu = document.querySelector('.nav__content');

        if(btn && menu) {
            btn.addEventListener('click', (e) => {
                e.preventDefault();
                btn.classList.toggle('js-open');
                menu.classList.toggle('js-open');
            });
        }
    }

    news() {
        const btn = document.querySelector('[href="/?news"]');
        if(btn) {
            btn.addEventListener('click', (e) => {
                e.preventDefault();
                Loader.openLoader(true);
            });
        }
    }
}